const URL = {
  Buying: '/buying',
  BuyingVPSGPU: '/buying-vps-gpu',
  BuyingProxy: '/buy-proxy',
  BuyingProxyResisdent: '/buy-proxy-resident',
  Account: '/account',
  Management: '/management',
  User: '/users',
  Reseller: '/resell',
  Server: '/servers',
  CheckProxy: '/checkproxy',
  CheckIP: '/checkip',
  Support: '/support',
  History: '/history',
  IPManagement: '/ip-management',
  Login: '/',
  Register: '/register',
  ForgotPassword: '/forgot',
  VerifyUser: '/verify',
  NotFound: '*',
  Transfer: '/transfer',
  Unauthorized: '/unauthorized',
  Notification: '/notification',
  LicenseManagement: '/license-management',
  Affiliate: '/affiliate',
};

export default URL;
